import React from 'react'
import { graphql } from 'gatsby'
import { css } from '@emotion/core'
import styled from '@emotion/styled'
import Layout from 'components/Layout'
import Link from 'components/Link'
import { useTheme } from 'components/Theming'
import Container from 'components/Container'
import { rhythm } from '../lib/typography'
import Helmet from 'react-helmet'

import Img from 'gatsby-image'


const ck_form = `<script src="https://f.convertkit.com/ckjs/ck.5.js"></script>
      <form action="https://app.convertkit.com/forms/1025297/subscriptions" class="seva-form formkit-form" method="post" data-sv-form="1025297" data-uid="7e85b529af" data-format="inline" data-version="5" data-options="{&quot;settings&quot;:{&quot;after_subscribe&quot;:{&quot;action&quot;:&quot;message&quot;,&quot;redirect_url&quot;:&quot;&quot;,&quot;success_message&quot;:&quot;Success! Now check your email to confirm your subscription.&quot;},&quot;return_visitor&quot;:{&quot;action&quot;:&quot;show&quot;,&quot;custom_content&quot;:&quot;&quot;},&quot;recaptcha&quot;:{&quot;enabled&quot;:false}}}" min-width="400 500 600 700 800"><div data-style="clean"><ul class="formkit-alert formkit-alert-error" data-element="errors" data-group="alert"></ul><div data-element="fields" data-stacked="false" class="seva-fields formkit-fields"><div class="formkit-field"><input class="formkit-input" aria-label="Your first name" name="fields[first_name]" placeholder="Your first name" type="text" style="color: rgb(0, 0, 0); border-color: rgb(227, 227, 227); border-radius: 4px; font-weight: 400;"></div><div class="formkit-field"><input class="formkit-input" name="email_address" placeholder="Your email address" required="" type="email" style="color: rgb(0, 0, 0); border-color: rgb(227, 227, 227); border-radius: 4px; font-weight: 400;"></div><button data-element="submit" class="formkit-submit formkit-submit" style="color: rgb(255, 255, 255); background-color: rgb(0, 102, 204); border-radius: 4px; font-weight: 400;"><div class="formkit-spinner"><div></div><div></div><div></div></div><span>Get access</span></button></div></div><style>.formkit-form[data-uid="7e85b529af"] *{font-family:"Helvetica Neue",Helvetica,Arial,Verdana,sans-serif;box-sizing:border-box;}.formkit-form[data-uid="7e85b529af"]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}.formkit-form[data-uid="7e85b529af"] legend{border:none;font-size:inherit;margin-bottom:10px;padding:0;position:relative;display:table;}.formkit-form[data-uid="7e85b529af"] fieldset{border:0;padding:0.01em 0 0 0;margin:0;min-width:0;}.formkit-form[data-uid="7e85b529af"] body:not(:-moz-handler-blocked) fieldset{display:table-cell;}.formkit-form[data-uid="7e85b529af"] h1,.formkit-form[data-uid="7e85b529af"] h2,.formkit-form[data-uid="7e85b529af"] h3,.formkit-form[data-uid="7e85b529af"] h4,.formkit-form[data-uid="7e85b529af"] h5,.formkit-form[data-uid="7e85b529af"] h6{color:inherit;font-size:inherit;font-weight:inherit;}.formkit-form[data-uid="7e85b529af"] p{color:inherit;font-size:inherit;font-weight:inherit;}.formkit-form[data-uid="7e85b529af"][data-format="modal"]{display:none;}.formkit-form[data-uid="7e85b529af"][data-format="slide in"]{display:none;}.formkit-form[data-uid="7e85b529af"] .formkit-input,.formkit-form[data-uid="7e85b529af"] .formkit-select,.formkit-form[data-uid="7e85b529af"] .formkit-checkboxes{width:100%;}.formkit-form[data-uid="7e85b529af"] .formkit-button,.formkit-form[data-uid="7e85b529af"] .formkit-submit{border:0;border-radius:5px;color:#ffffff;cursor:pointer;display:inline-block;text-align:center;font-size:15px;font-weight:500;cursor:pointer;margin-bottom:15px;overflow:hidden;padding:0;position:relative;vertical-align:middle;}.formkit-form[data-uid="7e85b529af"] .formkit-button:hover,.formkit-form[data-uid="7e85b529af"] .formkit-submit:hover,.formkit-form[data-uid="7e85b529af"] .formkit-button:focus,.formkit-form[data-uid="7e85b529af"] .formkit-submit:focus{outline:none;}.formkit-form[data-uid="7e85b529af"] .formkit-button:hover > span,.formkit-form[data-uid="7e85b529af"] .formkit-submit:hover > span,.formkit-form[data-uid="7e85b529af"] .formkit-button:focus > span,.formkit-form[data-uid="7e85b529af"] .formkit-submit:focus > span{background-color:rgba(0,0,0,0.1);}.formkit-form[data-uid="7e85b529af"] .formkit-button > span,.formkit-form[data-uid="7e85b529af"] .formkit-submit > span{display:block;-webkit-transition:all 300ms ease-in-out;transition:all 300ms ease-in-out;padding:12px 24px;}.formkit-form[data-uid="7e85b529af"] .formkit-input{background:#ffffff;font-size:15px;padding:12px;border:1px solid #e3e3e3;-webkit-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;line-height:1.4;margin:0;-webkit-transition:border-color ease-out 300ms;transition:border-color ease-out 300ms;}.formkit-form[data-uid="7e85b529af"] .formkit-input:focus{outline:none;border-color:#1677be;-webkit-transition:border-color ease 300ms;transition:border-color ease 300ms;}.formkit-form[data-uid="7e85b529af"] .formkit-input::-webkit-input-placeholder{color:inherit;opacity:0.8;}.formkit-form[data-uid="7e85b529af"] .formkit-input::-moz-placeholder{color:inherit;opacity:0.8;}.formkit-form[data-uid="7e85b529af"] .formkit-input:-ms-input-placeholder{color:inherit;opacity:0.8;}.formkit-form[data-uid="7e85b529af"] .formkit-input::placeholder{color:inherit;opacity:0.8;}.formkit-form[data-uid="7e85b529af"] [data-group="dropdown"]{position:relative;display:inline-block;width:100%;}.formkit-form[data-uid="7e85b529af"] [data-group="dropdown"]::before{content:"";top:calc(50% - 2.5px);right:10px;position:absolute;pointer-events:none;border-color:#4f4f4f transparent transparent transparent;border-style:solid;border-width:6px 6px 0 6px;height:0;width:0;z-index:999;}.formkit-form[data-uid="7e85b529af"] [data-group="dropdown"] select{height:auto;width:100%;cursor:pointer;color:#333333;line-height:1.4;margin-bottom:0;padding:0 6px;-webkit-appearance:none;-moz-appearance:none;appearance:none;font-size:15px;padding:12px;padding-right:25px;border:1px solid #e3e3e3;background:#ffffff;}.formkit-form[data-uid="7e85b529af"] [data-group="dropdown"] select:focus{outline:none;}.formkit-form[data-uid="7e85b529af"] [data-group="checkboxes"]{text-align:left;margin:0;}.formkit-form[data-uid="7e85b529af"] [data-group="checkboxes"] [data-group="checkbox"]{margin-bottom:10px;}.formkit-form[data-uid="7e85b529af"] [data-group="checkboxes"] [data-group="checkbox"] *{cursor:pointer;}.formkit-form[data-uid="7e85b529af"] [data-group="checkboxes"] [data-group="checkbox"]:last-of-type{margin-bottom:0;}.formkit-form[data-uid="7e85b529af"] [data-group="checkboxes"] [data-group="checkbox"] input[type="checkbox"]{display:none;}.formkit-form[data-uid="7e85b529af"] [data-group="checkboxes"] [data-group="checkbox"] input[type="checkbox"] + label::after{content:none;}.formkit-form[data-uid="7e85b529af"] [data-group="checkboxes"] [data-group="checkbox"] input[type="checkbox"]:checked + label::after{border-color:#ffffff;content:"";}.formkit-form[data-uid="7e85b529af"] [data-group="checkboxes"] [data-group="checkbox"] input[type="checkbox"]:checked + label::before{background:#10bf7a;border-color:#10bf7a;}.formkit-form[data-uid="7e85b529af"] [data-group="checkboxes"] [data-group="checkbox"] label{position:relative;display:inline-block;padding-left:28px;}.formkit-form[data-uid="7e85b529af"] [data-group="checkboxes"] [data-group="checkbox"] label::before,.formkit-form[data-uid="7e85b529af"] [data-group="checkboxes"] [data-group="checkbox"] label::after{position:absolute;content:"";display:inline-block;}.formkit-form[data-uid="7e85b529af"] [data-group="checkboxes"] [data-group="checkbox"] label::before{height:16px;width:16px;border:1px solid #e3e3e3;background:#ffffff;left:0px;top:3px;}.formkit-form[data-uid="7e85b529af"] [data-group="checkboxes"] [data-group="checkbox"] label::after{height:4px;width:8px;border-left:2px solid #4d4d4d;border-bottom:2px solid #4d4d4d;-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg);left:4px;top:8px;}.formkit-form[data-uid="7e85b529af"] .formkit-alert{background:#f9fafb;border:1px solid #e3e3e3;border-radius:5px;-webkit-flex:1 0 auto;-ms-flex:1 0 auto;flex:1 0 auto;list-style:none;margin:25px auto;padding:12px;text-align:center;width:100%;}.formkit-form[data-uid="7e85b529af"] .formkit-alert:empty{display:none;}.formkit-form[data-uid="7e85b529af"] .formkit-alert-success{background:#d3fbeb;border-color:#10bf7a;color:#0c905c;}.formkit-form[data-uid="7e85b529af"] .formkit-alert-error{background:#fde8e2;border-color:#f2643b;color:#ea4110;}.formkit-form[data-uid="7e85b529af"] .formkit-spinner{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;height:0px;width:0px;margin:0 auto;position:absolute;top:0;left:0;right:0;width:0px;overflow:hidden;text-align:center;-webkit-transition:all 300ms ease-in-out;transition:all 300ms ease-in-out;}.formkit-form[data-uid="7e85b529af"] .formkit-spinner > div{margin:auto;width:12px;height:12px;background-color:#fff;opacity:0.3;border-radius:100%;display:inline-block;-webkit-animation:formkit-bouncedelay-formkit-form-data-uid-7e85b529af- 1.4s infinite ease-in-out both;animation:formkit-bouncedelay-formkit-form-data-uid-7e85b529af- 1.4s infinite ease-in-out both;}.formkit-form[data-uid="7e85b529af"] .formkit-spinner > div:nth-child(1){-webkit-animation-delay:-0.32s;animation-delay:-0.32s;}.formkit-form[data-uid="7e85b529af"] .formkit-spinner > div:nth-child(2){-webkit-animation-delay:-0.16s;animation-delay:-0.16s;}.formkit-form[data-uid="7e85b529af"] .formkit-submit[data-active] .formkit-spinner{opacity:1;height:100%;width:50px;}.formkit-form[data-uid="7e85b529af"] .formkit-submit[data-active] .formkit-spinner ~ span{opacity:0;}.formkit-form[data-uid="7e85b529af"] .formkit-powered-by[data-active="false"]{opacity:0.35;}@-webkit-keyframes formkit-bouncedelay-formkit-form-data-uid-7e85b529af-{0%,80%,100%{-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);}40%{-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);}}@keyframes formkit-bouncedelay-formkit-form-data-uid-7e85b529af-{0%,80%,100%{-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);}40%{-webkit-transform:scale(1);-ms-transform:scale(1);transform:scale(1);}} .formkit-form[data-uid="7e85b529af"]{max-width:700px;}.formkit-form[data-uid="7e85b529af"] [data-style="clean"]{width:100%;}.formkit-form[data-uid="7e85b529af"] .formkit-fields{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:0 auto;}.formkit-form[data-uid="7e85b529af"] .formkit-field,.formkit-form[data-uid="7e85b529af"] .formkit-submit{margin:0 0 15px 0;-webkit-flex:1 0 100%;-ms-flex:1 0 100%;flex:1 0 100%;}.formkit-form[data-uid="7e85b529af"] .formkit-powered-by{color:#7d7d7d;display:block;font-size:12px;margin:0;text-align:center;}.formkit-form[data-uid="7e85b529af"][min-width~="700"] [data-style="clean"],.formkit-form[data-uid="7e85b529af"][min-width~="800"] [data-style="clean"]{padding:10px;}.formkit-form[data-uid="7e85b529af"][min-width~="700"] .formkit-fields[data-stacked="false"],.formkit-form[data-uid="7e85b529af"][min-width~="800"] .formkit-fields[data-stacked="false"]{margin-left:-5px;margin-right:-5px;}.formkit-form[data-uid="7e85b529af"][min-width~="700"] .formkit-fields[data-stacked="false"] .formkit-field,.formkit-form[data-uid="7e85b529af"][min-width~="800"] .formkit-fields[data-stacked="false"] .formkit-field,.formkit-form[data-uid="7e85b529af"][min-width~="700"] .formkit-fields[data-stacked="false"] .formkit-submit,.formkit-form[data-uid="7e85b529af"][min-width~="800"] .formkit-fields[data-stacked="false"] .formkit-submit{margin:0 5px 15px 5px;}.formkit-form[data-uid="7e85b529af"][min-width~="700"] .formkit-fields[data-stacked="false"] .formkit-field,.formkit-form[data-uid="7e85b529af"][min-width~="800"] .formkit-fields[data-stacked="false"] .formkit-field{-webkit-flex:100 1 auto;-ms-flex:100 1 auto;flex:100 1 auto;}.formkit-form[data-uid="7e85b529af"][min-width~="700"] .formkit-fields[data-stacked="false"] .formkit-submit,.formkit-form[data-uid="7e85b529af"][min-width~="800"] .formkit-fields[data-stacked="false"] .formkit-submit{-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto;} </style></form>`

const Description = styled.p`
  margin-bottom: 10px;
  display: inline-block;
`

export default function Index({ data: { site, allMdx, mdxCount } }) {
  const theme = useTheme()
  return (
    <Layout site={site} noFooter={false} noTopLink={true}>
      <Helmet>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:creator" content="@chrisachard" />
        <meta name="twitter:title" content='Chris Achard' />
        <meta name="twitter:description" content='Teaching everything I know about software: React, JS, Rails, Node.js' />
        <meta name="twitter:image" content='https://chrisachard.com/chris_twitter.png' />
      </Helmet>

      <Container
        css={css`
          padding-bottom: 0;
        `}
      >
        <div style={{
          backgroundColor: '#fff',
          border: "1px solid #eee",
          borderRadius: 10,
          display: 'flex',
          // justifyContent: 'center',
          // alignItems: 'center'
        }}
        css={css`
          flex-direction: column;
          @media (min-width: 700px) {
            flex-direction: row;
            // align-items: center;
          }
        `}
        >
          <div style={{
            display: 'flex',
            flex: 1,
            minWidth: 260,
            backgroundColor: '#0066cc',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
            css={css`
              border-bottom: 1px solid #eee;
              border-right: 0;
              border-top-left-radius: 10px;
              border-top-right-radius: 10px;
              border-bottom-left-radius: 0px;
              @media (min-width: 700px) {
                border-right: 1px solid #eee;
                border-bottom: 0;
                border-top-right-radius: 0px;
                border-bottom-left-radius: 10px;
              }
            `}
          >
            <div style={{
              padding: 10,
              borderTopLeftRadius: 10,
              textAlign: 'center',
              paddingTop: 40,
              paddingBottom: 40
            }}
            >
              <img 
                src="images/chris_new.png" 
                alt="Chris" 
                title="Chris"
                style={{
                  width: 200,
                  height: 200,
                  margin: "0 auto",
                  border: "5px solid #fff",
                  borderRadius: 100
                }}
              />
              

            </div>

          </div>
          <div style={{
            flex: 1,
            padding: 20,
            minWidth: 260,
            paddingBottom: 0,
            textAlign: 'center',
            backgroundColor: '#0066cc',
          }}

            css={css`
              display: flex;
              flex-direction: column;
              border-right: 0;
              border-radius: 0px;
              border-bottom-right-radius: 10px;
              border-bottom-left-radius: 10px;
              @media (min-width: 700px) {
                border-bottom: 0;
                border-radius: 0px;
                border-top-right-radius: 10px;
                border-bottom-right-radius: 10px;
              }
            `}
            >

            <h2 style={{
              color: '#fff',
              margin: 0,
              padding: 0,
              textAlign: 'center',
              display: 'flex', 
              flexDirection: 'column',
              flex: 1
            }}>Hi! I'm Chris</h2>


            <p css={css`
              color: #fff;
              font-family:"Helvetica Neue",Helvetica,Arial,Verdana,sans-serif;
            `}>Teaching everything I know about software development</p>


            <div      
              css={css`
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: bottom;
                padding-bottom: 40px;
                a {
                  background-color: #fff;
                  border-radius: 30px;
                  display: block;
                  display: flex;
                  justify-content: center;
                  align-items: bottom;
                  border: 4px solid #fff;
                  align-text: center;
                  padding: 0;
                  margin: 0;
                  margin-left: 10px;
                  margin-right: 10px;
                }
                a img {
                  width: 26px;
                  height: 26px;
                  margin: 12px;
                }
                a:hover {
                  border: 4px solid #44aaff;
                }
                a:hover img {
                  width: 24px;
                  height: 24px;
                  margin: 13px;
                }
              `}
            >
              <a href="https://twitter.com/chrisachard" target="_blank" rel="noopener noreferrer">
                <img src="images/twitter.png" alt="twitter" title="twitter" />
              </a>
              <a href="mailto:chris@chrisachard.com" target="_blank" rel="noopener noreferrer">
                <img src="images/mail.png" alt="mail" title="mail" />
              </a>
            </div>

          </div>
        </div>


        <div style={{
          marginTop: 50,
          marginBottom: 50,
          display: 'none'
        }}>

          <h3 style={{ color: '#888', marginBottom: 20 }}>What I'm Working On</h3>
          <div css={css`
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            flex-wrap: wrap;
            .react-screencasts {
              width: 90%;
              margin-bottom: 40px;
              border: 1px solid #ddd;
              padding: 10px;
              border-radius: 10px;
              box-shadow: 1px 1px 4px #ddd;
              display: flex;
              flex-directon: row;
              justify-content: flex-start;
            }
            .react-screencasts:hover {
              box-shadow: 2px 2px 4px #bbb;
              background-color: #f5f5f5;
            }
            .react-screencasts img {
              margin: 0;
              margin-bottom: 10px;
              width: 250px;
              margin-right: 20px;
            }
            .react-screencasts h1 {
              margin: 0;
              font-size: 1.5rem;
            }
            .react-screencasts:hover {
              text-decoration: none;
            }
            .react-screencasts:hover .tweet-link {
              text-decoration: underline;
            }
            .react-screencasts .tweet-link {
              text-align: right;
              font-size: 12px;
              font-style: italic;
              margin-top: 10px;
            }
            .react-screencasts:hover h1 {
              text-decoration: underline;
            }
            .react-screencasts p {
              color: #444;
              margin-bottom: 0;
            }
            @media (max-width: 700px) {
              .react-screencasts {
                flex-direction: column;
                justify-content: flex-start;
              }
              .react-screencasts img {
                width: 100%;
                margin-right: 0;
              }
            }
          `}>


            <a 
              href="https://meetingplace.io" 
              className="react-screencasts"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/images/meeting_place.png" alt="React Screencasts" title="React Screencasts" />
              <div style={{ flex: 1 }}>
                <h1>MeetingPlace.io</h1>
                <p>An alternative to Meetup</p>
                <p>Organize groups and events <span role="img" aria-label="ticket">🎟</span></p>                
                <div className="tweet-link">Check it out →</div>
              </div>
            </a>


            <a 
              href="https://reactscreencasts.com" 
              className="react-screencasts"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/images/react_screencasts_tweet.png" alt="React Screencasts" title="React Screencasts" />
              <div style={{ flex: 1 }}>
                <h1>React Screencasts</h1>
                <p>Learn React <i>FAST</i></p>
                <p>And then stay up-to-date  <span role="img" aria-label="unicorn">🦄</span></p>                
                <div className="tweet-link">Check it out →</div>
              </div>
            </a>

          </div>
        </div>



        <div style={{
          marginTop: 50,
          marginBottom: 50,
        }}>
          <h3 style={{ color: '#888', marginBottom: 20 }}>Crash Courses</h3>
          <div css={css`
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            flex-wrap: wrap;
            .crash-course {
              max-width: 300px;
              margin-bottom: 40px;
              border: 1px solid #ddd;
              padding: 10px;
              border-radius: 10px;
              box-shadow: 1px 1px 4px #ddd;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            }
            .crash-course:hover {
              box-shadow: 2px 2px 4px #bbb;
              background-color: #f5f5f5;
            }
            .crash-course img {
              margin: 0;
              margin-bottom: 10px;
            }
            .crash-course h1 {
              margin: 0;
              font-size: 1.5rem;
            }
            .crash-course:hover {
              text-decoration: none;
            }
            .crash-course:hover .tweet-link {
              text-decoration: underline;
            }
            .crash-course .tweet-link {
              text-align: right;
              font-size: 12px;
              font-style: italic;
            }
            .crash-course:hover h1 {
              text-decoration: underline;
            }
            .crash-course p {
              color: #444;
            }
          `}>


            <a 
              href="https://twitter.com/chrisachard/status/1188870256971915265" 
              className="crash-course"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/images/crash-courses/dns-crash-course.png" alt="DNS" title="DNS" />
              <div>
                <h1>DNS Records for Web Developers</h1>
                <p>ALIAS, CNAME, and A Records... oh my! <span role="img" aria-label="think">🌐</span></p>
                <div className="tweet-link">10 Tweets →</div>
              </div>
            </a>

            <a 
              href="https://twitter.com/chrisachard/status/1179015849459507200" 
              className="crash-course"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/images/crash-courses/redux-crash-course.png" alt="React with Hooks" title="React With Hooks" />
              <div>
                <h1>Redux Crash Course (with hooks)</h1>
                <p>Redux is a way to share state across your entire application <span role="img" aria-label="think">🌀</span></p>
                <div className="tweet-link">10 Tweets →</div>
              </div>
            </a>


            <a 
              href="https://twitter.com/chrisachard/status/1175022111758442497" 
              className="crash-course"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/images/crash-courses/react-with-hooks.png" alt="React with Hooks" title="React With Hooks" />
              <div>
                <h1>Learn React in 10 Tweets (with hooks)</h1>
                <p>Struggling to learn react?  Here's 10 tweets that will get you started.  Yes really! <span role="img" aria-label="think">🦄</span></p>
                <div className="tweet-link">10 Tweets →</div>
              </div>
            </a>


            <a 
              href="https://twitter.com/chrisachard/status/1173750491458789378" 
              className="crash-course"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/images/crash-courses/map-filter-reduce.png" alt="Map/Filter/Reduce Crash Course" title="Map/Filter/Reduce Crash Course" />
              <div>
                <h1>map/filter/reduce</h1>
                <p>Have you heard about map, filter, and reduce, but never really understood them? <span role="img" aria-label="think">🤔</span></p>
                <div className="tweet-link">10 Tweets →</div>
              </div>
            </a>


            <p><a href="/crash-courses">+ 3 more (see all)</a></p>


          </div>
        </div>



        <div style={{
          marginTop: 50,
          marginBottom: 50,
        }}>
          <h3 style={{ color: '#888', marginBottom: 20 }}>Latest Articles</h3>
          <div css={css`
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            flex-wrap: wrap;
          `}>

           {allMdx.edges.map(({ node: post }) => {
             return <div
               key={post.id}
               css={css`
                 max-width: 300px;
                 margin-bottom: 40px;
                 border: 1px solid #ddd;
                 padding: 10px;
                 border-radius: 10px;
                 box-shadow: 1px 1px 4px #ddd;
                 &:hover {
                   box-shadow: 2px 2px 4px #bbb;
                   background-color: #f5f5f5;
                 }
               `}
             >
              {post.frontmatter.banner && (
                <div
                  css={css`
                  `}
                >
                  <Link
                    aria-label={`View ${post.frontmatter.title} article`}
                    to={`/${post.fields.slug}`}
                  >
                    <Img sizes={post.frontmatter.banner.childImageSharp.sizes} />
                  </Link>
                </div>
              )}
               <h2
                 css={css({
                   marginBottom: rhythm(0.3),
                   transition: 'all 150ms ease',
                   ':hover': {
                     color: theme.colors.primary,
                   },
                 })}
               >
                 <Link
                   to={post.frontmatter.slug}
                   aria-label={`View ${post.frontmatter.title}`}
                 >
                   {post.frontmatter.title}
                 </Link>
               </h2>
               <Description>
                 {post.excerpt}{' '}
                 <br />
                 <Link
                   to={post.frontmatter.slug}
                   aria-label={`View ${post.frontmatter.title}`}
                 >
                   Read Article →
                 </Link>
               </Description>
             </div>
           })}
            <p><a href="/blog">+ {mdxCount.totalCount - 4} more (see all)</a></p>

         </div>
        </div>


        <div style={{
          marginTop: 50,
          marginBottom: 150,
        }}>
          <h3 style={{ color: '#888' }}>Online Courses</h3>
          <p style={{ color: '#444' }}>You can find the courses I create in the following places:</p>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            maxWidth: 300,
            margin: "0 auto",
          }}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <img 
                src="images/egghead.png" 
                alt="egghead" title="egghead"
                style={{ height: 75, marginBottom: 10 }}
              />
              <a href="https://egghead.io/instructors/chris-achard?af=8c1krm" target="_blank" rel="noopener noreferrer">egghead</a>
            </div>


            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <img 
                src="images/pluralsight.png" 
                alt="pluralsight" title="pluralsight"
                style={{ height: 75, marginBottom: 10 }}
              />
              <a href="https://app.pluralsight.com/profile/author/chris-achard" target="_blank" rel="noopener noreferrer">pluralsight</a>
            </div>
          </div>

        </div>

      </Container>
    </Layout>
  )
}


export const pageQuery = graphql`
  query {
    site {
      ...site
      siteMetadata {
        title
      }
    }
    mdxCount: allMdx (
      filter: { frontmatter: { published: { ne: false } } }
    ) {
      totalCount
    }
    allMdx(
      limit: 4
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { published: { ne: false } } }
    ) {
      edges {
        node {
          excerpt(pruneLength: 50)
          id
          fields {
            title
            slug
            date
          }
          parent {
            ... on File {
              sourceInstanceName
            }
          }
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            description
            banner {
              childImageSharp {
                sizes(maxWidth: 720) {
                  ...GatsbyImageSharpSizes
                }
              }
            }
            slug
            keywords
          }
        }
      }
    }
  }
`
